import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../api.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Element as StripeElement, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
import { MatInput } from '@angular/material/input';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { CancelSubscriptionComponent } from './cancel-subscription/cancel-subscription.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { OkHtmlModalComponent } from 'src/app/generic-components/ok-html-modal/ok-html-modal.component';
import { DateAdapter } from '@angular/material/core';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-subscription-details',
    templateUrl: './subscription-details.component.html',
    styleUrls: ['./subscription-details.component.css'],
    providers: [NgxSpinnerService]
})

export class SubscriptionDetailsComponent implements OnInit {
    error: any;
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
    remaining_days:any;
    total_days:any;
    days_passed:any;
    nextPeriod:any;
    currentTotal:any;
    nextTotal:any;
    startDate:any;
    endDate:any;
    subscriptionEndDate:any;
    nextStartDate:any;
    expDate:any;
    displayedColumns: string[] = ['periodStartDate', 'transactionDate', 'paidAmount', 'transactionApproved', 'transactionStatus', 'actions'];
    dataSource:any;
    userCount:any;
    subHistory:any;

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild('fromInput', {read: MatInput, static:true}) fromInput: MatInput;
    @ViewChild('toInput', {read: MatInput, static:true}) toInput: MatInput;
      
   
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    elementsOptions: ElementsOptions = {
        locale: (localStorage.getItem('language') && localStorage.getItem('language') == 'es')?'es':'en'
    };

    userId:any;
    total:any;
    organization:any;
    subscription:any;
    email:any;

    yearList = [];
    public max: Date = new Date ("12/31/"+(new Date()).getFullYear().toString()); 
    public min: Date = new Date ("01/01/"+((new Date()).getFullYear()-4).toString());
    currentDate:any;
    lastWeek:any;

    keep_plan:any;

    receiptDateForm = this.formBuilder.group({
        picker: this.formBuilder.group({
          startDate: '',
          endDate: ''
        })
      });

    constructor(private apiService: ApiService,
        public functionsService:FunctionsService, 
        public router: Router, 
        private modalService: NgbModal,
        private translate: TranslateService,
        private formBuilder: UntypedFormBuilder,
        private dateAdapter: DateAdapter<Date>,
        private spinner: NgxSpinnerService){
            this.translate.setDefaultLang('en');
            this.functionsService.setTitle('account.subscription-details');
            this.getScreenSize();
        } 

    ngOnInit(){
        this.dataSource = new MatTableDataSource<any>();
        this.dateAdapter.setLocale(this.language);  
        this.translate.onLangChange.subscribe((event) => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.language = event.lang;
            this.dateAdapter.setLocale(this.language); 
            this.language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
        });
        this.spinner.show();
        this.nextPeriod = null;
        this.keep_plan = null;
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.userId = this.functionsService.getUserId();
        this.email = this.functionsService.getEmail();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.getSubscription();
        this.getUserCount();
        this.getSubscriptionHistory();
        this.getPaymentHistory();
    }

    getSubscription(){
        this.apiService.getCurrentSubscription().subscribe(
            data => {
                this.subscription = data;
                if(this.subscription.cycle == "Y"){
                    this.subscription.cycle = "yearly";
                    this.subscription.price = this.subscription.yearlyPrice;
                }else {
                    this.subscription.cycle = "monthly";
                    this.subscription.price = this.subscription.monthlyPrice;
                }
                this.subscriptionEndDate = this.subscription.periodEndDate;
                if(this.subscription.nextPeriodId != 0){
                    this.getNextPeriod(this.subscription.nextPeriodId);
                }
                
                var currentDate = new Date();
                currentDate = new Date(currentDate.getMonth()+1+"/"+currentDate.getDate()+"/"+currentDate.getFullYear());
                var sDate = new Date(this.subscription.periodStartDate); 
                this.startDate = sDate.getMonth()+1+"/"+sDate.getDate()+"/"+sDate.getFullYear();
                sDate = new Date(sDate.getMonth()+1+"/"+sDate.getDate()+"/"+sDate.getFullYear());

                var eDate = new Date(this.subscription.periodEndDate);
                this.endDate = this.subscription.periodEndDate;
                eDate = new Date(eDate.getMonth()+1+"/"+eDate.getDate()+"/"+eDate.getFullYear());
                this.expDate = this.endDate;

                var difference = eDate.getTime() - sDate.getTime(); 
                this.total_days =  Math.ceil(difference / (1000 * 3600 * 24))+1; 

                this.remaining_days = this.functionsService.remainingDays(currentDate,eDate);
                
                this.days_passed = (this.total_days - this.remaining_days);
                this.days_passed = this.days_passed>=0?this.days_passed:this.total_days;
                this.currentTotal = this.functionsService.currencyFormat(this.subscription.paidAmount);
                document.getElementById('progress').style.cssText = "width:"+((this.days_passed/this.total_days)*100)+"%";
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getNextPeriod(periodId){
        this.apiService.getPeriod(periodId).subscribe(
            data => {
                if(data!=null){
                    this.nextPeriod = data;
                    this.nextTotal = this.functionsService.currencyFormat(this.nextPeriod.price);
                    this.nextStartDate = this.nextPeriod.startDate;
                    this.nextPeriod.cycle = (this.nextPeriod.cycle=="Y")?"yearly":"monthly";
                    if(this.nextPeriod.paid){
                        this.currentTotal = this.functionsService.currencyFormat(this.nextPeriod.paidAmount);
                        this.subscriptionEndDate = this.nextPeriod.endDate;
                        this.expDate = this.nextPeriod.endDate;
                    }
                    if(this.nextPeriod.planName){
                        this.translate.onLangChange.subscribe(() => {
                            this.keep_plan = this.translate.instant('account.keep_current_plan');
                            this.keep_plan = this.keep_plan.replace("##DATE##", (this.functionsService.convertUTCDateToLocalDateOnly(this.nextPeriod.startDate)));
                            this.keep_plan = this.keep_plan.replace("##PLAN_NAME##", (this.translate.instant((this.nextPeriod.planName))));
                        });
                        this.keep_plan = this.translate.instant('account.keep_current_plan');
                        this.keep_plan = this.keep_plan.replace("##DATE##", (this.functionsService.convertUTCDateToLocalDateOnly(this.nextPeriod.startDate)));
                        this.keep_plan = this.keep_plan.replace("##PLAN_NAME##", (this.translate.instant((this.nextPeriod.planName))));
                    }
                }
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    getPaymentsByRange(){
        if(this.receiptDateForm && this.receiptDateForm.value.picker.startDate){
            var sd = new Date(this.receiptDateForm.value.picker.startDate);
            var ed = new Date(this.receiptDateForm.value.picker.endDate);
            var startDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
            var endDate = (ed.getMonth()+1)+"-"+ed.getDate()+"-"+ed.getFullYear();
            this.apiService.getPaymentsByDateRange(startDate,endDate).subscribe(
                resp => {
                    this.dataSource.data = resp;
                },
                error => {
                    this.functionsService.errorHandler(error["status"]);
                }
            );
        } else{
            this.getPaymentHistory();
        }
    }

    resetForm() {
        this.receiptDateForm.reset();
        this.fromInput.value = '';
        this.toInput.value = '';
    }

    getSubscriptionHistory(){
        this.apiService.getSubscriptionHistory().subscribe(
            data => {
                this.subHistory = data;
            },
            error => {
                
            }
        );
    }

    getPaymentHistory(){
        this.apiService.getPaymentHistory().subscribe(
            resp => {
                this.dataSource.data = resp;
                this.dataSource.data.forEach(element => {
                    if(element['transactionStatus'] == null){
                        element['transactionStatus'] = "succeeded";
                    }
                });
                this.dataSource.data = resp;
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page"); 
                }
                this.spinner.hide();
            }
        );
    }

    getUserCount(){
        this.apiService.getUserCount().subscribe(
            resp => {
                this.userCount = resp;
            }
        );
    }

    cancelSubscription(){
        const modalRef = this.modalService.open(CancelSubscriptionComponent, { size: 'xl' });
        modalRef.componentInstance.subscriptionId = this.subscription.id;
        modalRef.componentInstance.endDate = this.subscriptionEndDate;
        modalRef.result.then(() => this.ngOnInit());
    }

    reactivateSubscription(){
        this.spinner.show();
        var currentDate = new Date();
        var expirationDate = new Date(this.expDate);

        if((currentDate<=expirationDate)){
            this.apiService.reactivateSubscription(this.subscription).subscribe(
                data => {
                    this.spinner.hide();
                    //Modal
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'xl' });
                    var reactivate_subs = this.translate.instant('account.reactivate_subscription_message');
                    reactivate_subs = reactivate_subs.replace("##INVOICE_DATE##", this.functionsService.convertUTCDateToLocalDateOnly(this.expDate));
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                    modalRef.componentInstance.message = reactivate_subs;
                    modalRef.result.then(() => this.ngOnInit());
                },
                error => {
                    this.spinner.hide();
                    this.functionsService.errorHandler(error["status"]);
                }
            );
        }
    }

    changeBillingCycle(){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('account.change_cycle');
        var current_cycle = this.subscription.cycle;
        var next_cycle = this.nextPeriod.cycle;
        var new_cycle = ((this.nextPeriod.cycle).toString()=="monthly")?"yearly":"monthly";
        var current_amount = ((this.nextPeriod.cycle).toString()=="yearly")?this.subscription.yearlyPrice:this.subscription.monthlyPrice;
        var new_amount = ((this.nextPeriod.cycle).toString()=="monthly")?this.subscription.yearlyPrice:this.subscription.monthlyPrice;
        var change_cycle_error = this.translate.instant('account.change_cycle_error');
            if(new_cycle == current_cycle){
                var message = this.translate.instant('account.change_cycle_message2');
            }
            else{
                var message = this.translate.instant('account.change_cycle_message');
            }
        message = message.replace("##CURRENT_CYCLE##", (this.translate.instant('account.'+current_cycle)).toLowerCase());
        message = message.split("##NEW_CYCLE##").join((this.translate.instant('account.'+new_cycle)).toLowerCase());
        message = message.split("##NEXT_CYCLE##").join((this.translate.instant('account.'+next_cycle)).toLowerCase());
        message = message.replace("##CURRENT_AMOUNT##", "$"+this.functionsService.currencyFormat(current_amount));
        message = message.replaceAll("##NEW_AMOUNT##", "$"+this.functionsService.currencyFormat(new_amount));
        message = message.replace("##PLAN_NAME##", (this.translate.instant((this.subscription.planName))));
        message = message.replace("##PAY_DATE##", this.functionsService.convertUTCDateToLocalDateOnly(this.nextStartDate));
        confirmModalRef.componentInstance.message = message;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.changeBillingCycle().subscribe(
                    () => {
                        this.spinner.hide();
                        this.ngOnInit();
                    },
                    error => {
                        this.spinner.hide();
                        if(error["error"]["content"] == "change_cycle_error")
                        {
                            const modalError = this.modalService.open(OkHtmlModalComponent);
                            modalError.componentInstance.title = this.translate.instant('account.change_cycle_error_title');
                            modalError.componentInstance.message = change_cycle_error;
                        }
                        else{
                        this.functionsService.errorHandler(error["status"]);
                        }
                    }
                );
            }
        });
    }

    keepCurrentPlan(){
        var message = this.translate.instant('account.keep_plan_message');

        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('account.keep_plan');
        message = message.replace("##NEW_PLAN##", (this.translate.instant((this.nextPeriod.planName))));
        message = message.replace("##CURRENT_PLAN##", (this.translate.instant((this.subscription.planName))));
        
        confirmModalRef.componentInstance.message = message;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.keepCurrentPlan().subscribe(
                    () => {
                        this.spinner.hide();
                        this.ngOnInit();
                    },
                    error => {
                        this.spinner.hide();
                        this.functionsService.errorHandler(error["status"]);
                    }
                );
            }            
        });
    }


    scrHeight: any;
    scrWidth: any;
    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['periodStartDate', 'transactionDate', 'paidAmount', 'transactionApproved', 'transactionStatus', 'actions'];

        if (this.scrWidth <= 403) {
            this.displayedColumns = ['periodStartDate', 'actions'];
        }
        else if (this.scrWidth <= 460) {
            this.displayedColumns = ['periodStartDate', 'paidAmount', 'actions'];
        }
        else if (this.scrWidth <= 768) {
            this.displayedColumns = ['periodStartDate', 'transactionDate', 'paidAmount', 'transactionStatus', 'actions'];
        }
    }
}